export default "__VITE_ASSET__CU9YZ$ys__"